<template>
  <div>
    <h2>Processing authentication for {{ source.label }} account</h2>
    <div class="progress">
      <div class="indeterminate"></div>
    </div>
  </div>
</template>

<script>
import sources from "@/sources"
import {getBaseUrl} from '@/utils'

export default {
  props: ['sourceId', 'query'],
  created () {
    let baseUrl = getBaseUrl(window.location.toString(), this.$router.currentRoute.path)
    this.source.handleCallback({baseUrl, query: this.query, router: this.$router, store: this.$store})
  },
  computed: {
    source () {
      return sources.sources[this.sourceId]
    }
  }
}
</script>
